<template>
    <div class="row">
        <slot/>
    </div>
</template>